import React from 'react';
import TextContainer from '../TextContainer';
import { withStyles, Typography, Link } from '@material-ui/core';
import styles from './Method.css';

function Method(props) {

    const {classes} = props;

    return (
        <div className={classes.method}>
            <TextContainer>
                <Typography variant="h5">Method</Typography>
                <br></br>
                <Typography variant="body1">The method uses maskRCNN, as it is described in Hollandi etal. – manuscript submitted. <Link target="_blank" rel="noopener" href={'https://www.biorxiv.org/content/10.1101/580605v1'}>[BioRxiv]</Link></Typography>
            </TextContainer>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(Method);
